import { HttpClient } from 'api/http-client';
import { IntegrationProviderMeta } from '..';
import {
  SlackChannel,
  SlackConfig,
  SlackNotificationEvent,
  SlackProjectSettings,
  SlackSettingsMeta,
  SlackUser,
} from './slack.types';

const baseUrl = '/integrations/slack';

class SlackHTTPClient extends HttpClient {
  public getSlackAuthMeta = (): Promise<IntegrationProviderMeta> =>
    this.get<IntegrationProviderMeta>('integration-providers/slack/meta');

  public disconnectSlackIntegration = (integrationId: number): Promise<void> =>
    this.delete<void>(`${baseUrl}/${integrationId}`);

  public getSlackConfig = (): Promise<SlackConfig[]> =>
    this.get<SlackConfig[]>(baseUrl);

  public updateSlackSettings = (
    integrationId: number,
    payload: SlackSettingsMeta,
  ): Promise<SlackSettingsMeta> =>
    this.put<SlackSettingsMeta, SlackSettingsMeta>(
      `${baseUrl}/${integrationId}/settings`,
      payload,
    );

  public getSlackChannels = (integrationId: number): Promise<SlackChannel[]> =>
    this.get<SlackChannel[]>(`${baseUrl}/${integrationId}/api/channels`);

  public getSlackUsers = (integrationId: number): Promise<SlackUser[]> =>
    this.get<SlackUser[]>(`${baseUrl}/${integrationId}/api/users`);

  public getNotificationsConfig = (
    integrationId: number,
  ): Promise<SlackNotificationEvent[]> =>
    this.get<SlackNotificationEvent[]>(
      `${baseUrl}/${integrationId}/settings/notification-config`,
    );

  public updateNotificationConfig = (
    integrationId: number,
    payload: SlackNotificationEvent[],
  ): Promise<SlackNotificationEvent[]> =>
    this.post<unknown, SlackNotificationEvent[], SlackNotificationEvent[]>(
      `${baseUrl}/${integrationId}/settings/notification-config`,
      payload,
    );

  public getProjectSlackSettings = (
    projectId: number,
  ): Promise<SlackProjectSettings> => {
    return this.get(`${baseUrl}/settings/project/${projectId}`);
  };

  public updateProjectSlackSettings = (
    projectId: number,
    payload: SlackProjectSettings,
  ): Promise<SlackProjectSettings> => {
    return this.put(`${baseUrl}/settings/project/${projectId}`, payload);
  };
}

export const SlackApi = new SlackHTTPClient();
